module.exports = __webpack_public_path__ + "13b871fdc1dfd57e421fe3340a89afdb.svg";